import { HttpParams } from '@angular/common/http';
import { PaginationRequest } from '@siat-fe/shared';

export class HttpParamsUtils {
  static create(pagination: PaginationRequest): HttpParams {
    let httpParams = new HttpParams();
    if (pagination) {
      Object.keys(pagination).forEach(key => {
        if (pagination[key]) {
          httpParams = httpParams.set(key, pagination[key]);
        }
      });
    }
    return httpParams;
  }

}
